import request from './request'
export function commit(data) {
        return request({
                url: '/api/v1/messageboard/commit',
                method: 'post',
                data,
                // headers: {
                //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                // },
        })
}